import { useCallback, useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@@/auto/hooks/redux';
import { getCmsContent as fetchCmsContent } from '@@/auto/store/actions';
import { getCmsContent } from '@@/auto/store/selectors';
import { isCmsError } from '@@/common/services/typeGuards';

export function useCmsContent(slug: string, fetchContent = fetchCmsContent) {
  const dispatch = useAppDispatch();
  const content = useAppSelector(getCmsContent(slug));

  useEffect(
    function fetchCmsContentIfMissing() {
      if (!content) {
        fetchContent([slug])(dispatch);
      }
    },
    [content, dispatch, slug, fetchContent]
  );

  return content;
}

export function useCmsContentAndHelpers(slug: string) {
  const content = useCmsContent(slug);

  const getEntryFieldBySlug = useCallback(
    (entrySlug: string, fieldSlug: string) => {
      if (isCmsError(content)) {
        return undefined;
      }
      return content?.entries
        ?.find((entry) => entry?.slug === entrySlug)
        ?.fields?.find((field) => field?.field_template?.slug === fieldSlug);
    },
    [content]
  );

  return { content, getEntryFieldBySlug };
}
